module.exports = __webpack_public_path__ + "files/pneumopathies.3da12400e59a9b831aa2b2c9a7731777.pdf";